import { SubscriptionContract } from 'types/SubscriptionContract';

export const useCurrencyCode = (subscription: SubscriptionContract) => {
  return subscription?.lines?.length ? subscription?.lines[0]?.current_price?.currency_code : 'USD';
};
